import { Subscription } from "./Subscription.js";
class AutoCloseSubscription extends Subscription {
  constructor(userUnsubscribe) {
    super(userUnsubscribe);
  }
}
export {
  AutoCloseSubscription
};
//# sourceMappingURL=AutoCloseSubscription.js.map
